import React from "react";
import { View, StyleSheet, Dimensions } from "react-native";
import ContentLoader, { Rect } from "react-content-loader/native";

const SkeletonLoader = ({
  rows = 3, 
  rowWidth = "100%", 
  rowHeight = 20,
  gap = 10, 
}) => {
  const screenWidth = Dimensions.get("window").width; 

  const resolvedWidth =
    rowWidth === "100%"
      ? "100%"
      : Math.min(parseInt(rowWidth, 10), screenWidth);

  return (
    <View style={styles.container}  testID="skeleton">
      {[...Array(rows)].map((_, index) => (
        <View
          testID="skeleton-row"
          key={index}
          style={{
            marginBottom: index !== rows - 1 ? gap : 0,
            width: resolvedWidth === "100%" ? "100%" : resolvedWidth, 
          }}
        >
          <ContentLoader
            speed={2}
            width="100%" 
            height={rowHeight}
            backgroundColor="#f3f3f3"
            foregroundColor="#ecebeb"
            viewBox={`0 0 ${
              resolvedWidth === "100%" ? screenWidth : resolvedWidth
            } ${rowHeight}`}
          >
            <Rect
              x="0"
              y="0"
              rx="4"
              ry="4"
              width="100%" 
              height={rowHeight}
            />
          </ContentLoader>
        </View>
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    width: "100%", 
  },
});

export default SkeletonLoader;
